import React from "react";
import Button from "@material-ui/core/Button";
import { Trans } from "react-i18next";
import Popup, {
  PopupActions,
  PopupButton,
  PopupContent,
  PopupHeading,
} from "../../../../../components/Common/Popup";

export default ({ open, handleCancel, handleOk, ...other }) => {
  return (
    <Popup
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth="xs"
      aria-labelledby="confirmation-dialog-title"
      open={open}
      {...other}
    >
      <PopupHeading id="confirmation-dialog-title">
        <Trans>Unsaved changes</Trans>
      </PopupHeading>
      <PopupContent dividers>
        <Trans>Do you want to abort without saving the changes?</Trans>
      </PopupContent>
      <PopupActions>
        <PopupButton secondary onClick={handleOk}>
          <Trans>Close without saving</Trans>
        </PopupButton>

        <PopupButton autoFocus onClick={handleCancel}>
          <Trans>Continue editing</Trans>
        </PopupButton>
      </PopupActions>
    </Popup>
  );
};
